import React, { useMemo } from 'react';
import { OptionKey, SelectDropdown } from '@common-fe/common-fe';

import { ALL_OPTION_KEY } from '@/common/constants';
import { useSelectAllHandler } from '@/modules/core';
import { CIP_STATUS_OPTIONS } from '@/modules/Reports/report.types';

interface Props {
  testId?: string;
  values: OptionKey[];
  disabled?: boolean;
  onChangeValues: (value: OptionKey[]) => void;
}
const CIPStatusSelector: React.FC<Props> = ({
  testId = 'cip-status_selector',
  disabled,
  values,
  onChangeValues,
}) => {
  const currentValue = useMemo(() => {
    if (!values.length && !disabled) {
      return [ALL_OPTION_KEY];
    }
    return values;
  }, [disabled, values]);

  const handleChangeValue = useSelectAllHandler(values, onChangeValues);

  return (
    <SelectDropdown
      key="cip-status_selector"
      ellipsisMode
      disabled={disabled}
      activeTitle
      testId={testId}
      options={CIP_STATUS_OPTIONS}
      values={currentValue}
      onChangeValues={handleChangeValue}
      prefix="CIP status"
      id="cip-status_selector"
      name="cip-status_selector"
      allMode
    />
  );
};

export default CIPStatusSelector;
